module.exports = __webpack_public_path__ + "static/media/falco_0.8d08dd9d.png";